<template>
  <custom-popup v-model="dialog" :cons="cons" max-width="920">
    <v-card class="pa-4" flat>
      <v-list-item v-if="!!parentCategory" @click="goBack">
        <v-list-item-action>
          <v-icon>mdi-arrow-right</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ parentCategory.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <transition mode="out-in" name="fade-transition">
        <v-row v-if="showProducts" key="products" class="pa-2" no-gutters>
          <v-col
            v-for="(item, i) in productList"
            :key="i"
            class="pa-2"
            cols="12"
            md="6"
          >
            <v-card
              class="rounded-lg fill-height"
              outlined
              @click="selectProduct(item)"
            >
              <v-list-item>
                <v-list-item-avatar size="48">
                  <v-img :src="item.gallery | getProductImage" contain />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="product-title">{{
                    item.name
                  }}</v-list-item-title>
                </v-list-item-content>

                <!--                <v-list-item-action>-->
                <!--                  <v-icon>mdi-{{ selectedProducts.includes(item.id) ? 'checkbox-marked' : 'checkbox-blank-outline'}}</v-icon>-->
                <!--                </v-list-item-action>-->
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-list v-else-if="currentCategories" key="list" dense>
          <template v-for="(cat, i) in currentCategories">
            <v-list-item :key="i" dense @click="showChildren(cat)">
              <v-list-item-avatar size="32">
                <v-img :src="cat.picture" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ cat.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon
                  v-if="
                    (!!cat.children && !!cat.children.length) ||
                    (!!cat.products && !!cat.products.length)
                  "
                >
                  mdi-chevron-left
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </transition>
    </v-card>
  </custom-popup>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "specialCategoryProductPicker",

  props: {
    value: Object,
    show: Boolean,
  },

  data() {
    return {
      loading: false,
      categories: [],
      currentCategories: [],
      parentCategory: null,
      showProducts: false,
      productList: [],
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    cons() {
      return {
        title: this.$t("selectproduct"),
        buttons: [
          { type: "close", handler: () => (this.currentCategories = []) },
        ],
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    dialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    // selectedProducts() {
    //   return this.value.products.map(item => item.id)
    // }
  },

  watch: {
    show(val) {
      !!val && !this.categories?.length && this.getProducts();
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    getProducts() {
      if (this.loading) return;

      this.loading = true;

      this.$api
        .get("v1/testQr/category-special-find-products", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => {
          this.categories = data.data;
          this.currentCategories = data.data;
        })
        .finally(() => (this.loading = false));
    },
    // Show the children of the selected category
    showChildren(category) {
      this.parentCategory = category; // store the parent category

      if (!!category.children?.length) {
        this.currentCategories = category.children;
      } else if (!!category.products?.length) {
        this.productList = category.products;
        this.showProducts = true;
      }
    },
    // Go back to the parent category
    goBack() {
      this.showProducts = false;

      if (this.parentCategory) {
        // If there's a parent, find its parent's children or set root categories
        const parent = this.findParent(this.parentCategory);

        if (parent) {
          this.currentCategories = parent.children;
          this.parentCategory = parent;
        } else {
          this.currentCategories = this.categories;
          this.parentCategory = null;
        }
      }
    },
    // Helper method to find the parent of the current category
    findParent(current) {
      const findRecursively = (categories) => {
        for (const category of categories) {
          if (category.children?.includes(current)) {
            return category;
          }

          if (!!category.children?.length) {
            const parent = findRecursively(category.children);
            if (parent) return parent;
          }
        }

        return null;
      };

      return findRecursively(this.categories);
    },
    // selectProduct
    selectProduct(product) {
      let index = this.value.products.findIndex(
        (item) => item.slug === product.slug
      );

      if (index >= 0) this.computedValue.products.splice(index, 1);
      else {
        let obj = {
          gallery: product.gallery,
          name: product.name,
          product_id: product.id,
          special_category_id: this.computedValue.id,
          total_quantity: product.inventory || 50,
          total_discount: 50,
          max_per_customer: 5,
          max_per_order: 5,
          expires_at: this.computedValue.expire_at,
        };

        this.computedValue.products.push({ ...obj });
      }

      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.product-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  white-space: normal;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
